module.exports = __webpack_public_path__ + "img/BOTELLA DE 64 OZ 1.9 L.cfad67c6.jpg";